"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function ProjectsRepository($resource) {
    var query = {
        method: 'GET',
        isArray: true
    };
    var create = {
        method: 'POST',
        isArray: false
    };
    return $resource('/partner/api/v2/projectsapi', {}, {
        query: query,
        create: create
    });
}
exports.ProjectsRepository = ProjectsRepository;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicHJvamVjdHMuYXBpLmZhY3RvcnkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJwcm9qZWN0cy5hcGkuZmFjdG9yeS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUdBLFNBQWdCLGtCQUFrQixDQUFDLFNBQTRDO0lBRTNFLElBQUksS0FBSyxHQUF1QztRQUM1QyxNQUFNLEVBQUUsS0FBSztRQUNiLE9BQU8sRUFBRSxJQUFJO0tBQ2hCLENBQUM7SUFFRixJQUFJLE1BQU0sR0FBdUM7UUFDN0MsTUFBTSxFQUFFLE1BQU07UUFDZCxPQUFPLEVBQUUsS0FBSztLQUNqQixDQUFDO0lBRUYsT0FBcUIsU0FBUyxDQUFDLDZCQUE2QixFQUFFLEVBQUUsRUFBRTtRQUM5RCxLQUFLLE9BQUE7UUFDTCxNQUFNLFFBQUE7S0FDVCxDQUFDLENBQUM7QUFDUCxDQUFDO0FBaEJELGdEQWdCQyJ9